module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_2.a3219320.png";